import type { EventsLocales } from '@/types/lang/locales'

export const eventsEn: EventsLocales = {
    actions: {
        affectFilters: 'Affect filters to this site',
        affectFiltersTitle: 'Affect filters',
        affectFiltersDevice: "Confirm and affect to this site's devices"
    },
    api: {
        error: {
            createSite: 'An error occured while creating the site {name}',
            deleteSite: 'An error occured while deleting the site {name}',
            fetchSite: 'An error occured while fetching the site',
            fetchSites: 'An error occured while fetching the sites',
            updateSite: 'An error occured while updating the site {name}'
        },
        success: {
            createSite: 'Site {name} successfully created !',
            deleteSite: 'Site {name} successfully deleted !',
            fetchSite: 'Site successfully fetched !',
            fetchSites: 'Sites successfully fetched !',
            updateSite: 'Site {name} successfully edited !'
        }
    },
    createSite: 'Create site',
    duplicatedSite: 'Duplicated site',
    button: {
        addCheckpoint: 'Add a POI',
        duplicateSite: 'Duplicate'
    },
    poi: {
        name: 'Name',
        comment: 'Comment',
        devicesList: 'Devices list',
        noDetectionFound: 'No detection found',
        noDeviceAssociated: 'No device associated'
    },
    detail: {
        informations: {
            informationsTitle: 'Information',
            siteLocalization: 'Site localization',
            partnerConfigTitle: 'Partner configuration',
            partnerConfigUpdate: 'Partner update'
        },
        pois: {
            poisTitle: 'POIs',
            createCheckpointTitle: 'Create new POI',
            partner: 'Partner'
        },
        detections: {
            detectionsTitle: 'Reads'
        },
        devices: {
            devicesTitle: 'Devices'
        }
    },
    detection: {
        table: {
            bib: 'Bib',
            poi: 'POI',
            timestamp: 'Date',
            device: 'Device',
            site_filter: 'Site filter',
            timer_filter: 'Timer filter'
        },
        liveDetections: 'Live reads',
        pastDetections: 'Previous reads'
    },
    filters: {
        archived: 'Archived',
        clientId: 'Client ID',
        date_limit: 'Date',
        end_at: 'End date',
        endAt: 'End of site',
        endDate: 'End date',
        siteName: 'Site name',
        field: 'Field',
        future: 'Future',
        past: 'Past',
        period: 'Period',
        showFinished: 'Show finished sites',
        showOngoing: 'Show ongoing sites',
        showUpcoming: 'Show upcoming sites',
        finished: 'Finished sites',
        ongoing: 'Ongoing sites',
        upcoming: 'Upcoming sites',
        start_at: 'Start of site',
        startAt: 'Start of site',
        startDate: 'Start date'
    },
    model: {
        clientId: 'Client ID',
        comment: 'Comment',
        endAt: 'End date',
        name: 'Site name',
        partnerName: 'Partner',
        partnerId: 'Partner ID',
        startAt: 'Start date',
        tz: 'Timezone'
    },
    table: {
        clientId: 'Client ID',
        comments: 'Comments',
        startDate: 'Start date',
        endDate: 'End date',
        siteName: 'Site name',
        duplicateSite: 'Are you sure you want to duplicate this site ?'
    },
    title: {
        actionsTitle: 'Actions'
    }
}
